export default __webpack_public_path__ + "static/media/Social Contagion and CAVs.38f764b1.pdf";